/* eslint-disable */
export default {
    form_project_name_placeholder: "Enter a name for the project",
    form_value_can_not_be_empty: "This value can not be empty",
    form_could_not_process_your_request: "Could not process your request",
    form_input_type_could_not_be_determined: "Input type could not be determined for type:",
    form_could_not_find_form_field: "Could not find form field with id:",
    form_submit: "Submit",
    form_loading_form: "Loading form",
    form_close: "Close",
    form_organisation_name: "Organisation name",
    form_job_function_name: "Job function name",
    form_job_function_name_placeholder: "Enter the job function name here",
    form_organisation_name_placeholder: "Enter the organisation name here",
    form_project_name: "Project name",
    form_project_product: "Product",
    form_option_product_selection: "Selection",
    form_option_product_development: "Development",
    form_option_product_selection_development: "Selection development",
    form_option_nederlands: "Dutch",
    form_option_engels: "English",
    form_account_first_name: "First name",
    form_account_infix: "Infix",
    form_account_last_name: "Last name",
    form_account_gender: "Gender",
    form_account_has_role_email: "Email address",
    form_account_has_role_language: "Language",
    form_education_level: "What is the required level of education?",
    form_participant_session_appointment_date: "Appointment date",
    form_comments: "Comments",
    form_consultant: "Consultant",
    form_option_male: "Male",
    form_option_female: "Female",
    form_option_other: "Other",
    form_participant_first_name_placeholder: "Enter the name of the participant",
    form_participant_infix_placeholder: "Enter the infix of the participant",
    form_participant_last_name_placeholder: "Enter the last name of the participant",
    form_participant_email_placeholder: "Enter the email address of the participant",
    form_option_choose_language: "Choose a language for the participant",
    form_participant_session_appointment_date_placeholder: "Select a date",
    form_comments_placeholder: "Please enter a comment",
    form_option_low: "Middle manual vocational program",
    form_option_middle: "Higher vocational program (Bachelor's degree)",
    form_option_high: "Master's degree",
    form_email: "Email address",
    form_account_email_placeholder: "Enter the email address of the user",
    form_account_role_label: "Role",
    form_display_name: "Display name",
    form_account_display_name_placeholder: "Enter a display name for the user",
    form_infix: "Infix",
    form_account_infix_placeholder: "Enter the infix of the user",
    form_account_last_name_placeholder: "Enter the last name of the user",
    form_last_name: "Last name",
    form_first_name: "First name",
    form_account_first_name_placeholder: "Enter the first name of the user",
    form_option_role_application_managers: "Application Manager",
    form_option_role_consultants: "Consultant",
    form_option_role_bedrijfsbureau: "Planning & Support",
    form_option_role_backoffice: "Backoffice",
    form_option_role_client_center: "Client Center",
    form_option_role_assessment_team: "Assessment team",
    form_option_role_assessors: "Assessor",
    form_gender: "Gender",
    form_option_choose_gender: "Choose a gender",
    form_stars_required: "* Required fields",
    form_option_choose_education_level: "Choose an education level",
    form_option_choose_consultant: "No consultant selected",
    form_option_choose_product: "Choose a product",
    form_option_choose_user_role: "Choose a role",
    form_error_not_blank: "This field cannot be empty",
    form_error_length_maximum: "The value of this field is too long",
    form_error_length_minimum: "The value of this field is too short",
    form_error_duplicate_entry: "This value does already exist",
    form_error_password_contains_spaces: "The password cannot contain spaces",
    form_error_password_do_not_match: "The passwords do not match",
    form_error_password_too_short: "The password should contain at least 8 characters",
    form_error_password_too_long: "The password is too long",
    form_error_invalid_email: "The email address is invalid",
    form_error_duplicate_non_participant_role: "This user was already invited with the selected role",
    form_error_invalid_field_value: "The value of this field is invalid",
    form_error_email_duplicate_in_project: "The participant does already exist",
    form_error_duplicate_custom_competency: "The competency does already exist",
    form_error_registration_user_already_exists: "This user does already exist. Choose login or forgot password to proceed.",
    form_cancel: "Cancel",
    form_highest_basic_education_level: "What is the highest level of primary or secondary education you have received?",
    form_highest_advanced_education_level: "What is the highest level of advanced education you have received?",
    form_highest_basic_education_level_placeholder: "Choose an education level",
    form_highest_advanced_education_level_placeholder: "Choose an education level",
    form_appendixes_to_hide_online: "Hidden Appendixes",
    form_account_date_of_birth: "Date of birth",
    form_appendixes_to_hide_pdf: "Hidden appendixes",
    form_option_persona_fit: "Persona.fit",
    form_option_working_styles: "Working Styles",
    form_option_influencing_styles: "Influencing styles",
    form_option_motives: "Motives",
    form_option_personality: "Personality",
    form_option_intellectual_capabilities: "Intellectual Capabilities",
    form_error_participant_session_invite_failed: "Sending email failed",
    form_form_fields_not_loaded: "Form fields do not exist! API call probably failed",
    update_participant_detail_save: "Save",
    update_participant_detail_page_heading: "Personal profile",
    update_participant_detail_form_heading: "Personal data",
    update_participant_detail_form_heading_label: "The following personal information is in our system",
    form_date_of_birth: "Date of birth",
    form_report_receivers_placeholder: "Report receivers",
    form_report_receivers: "Report receivers",
    form_sub_organisation_name_placeholder: "Enter the sub organisation name here",
    form_sub_organisation_name: "Sub organisation name",
    form_report_receiver_account_gender: "Gender",
    form_report_receiver_account_has_role_email: "Email",
    form_report_receiver_account_last_name: "Last name",
    form_report_receiver_account_infix: "Infix",
    form_report_receiver_account_first_name: "First name",
    form_error_report_receiver_already_exists: "This report receiver already exists, please select it from the list",
    form_option_role_office_manager: "Office Manager",
    form_choose_organisations_title: "Organisations",
    form_choose_project_title: "Project",
    form_product_selection: "Selection",
    form_product_selection_development: "Selection Development",
    form_product_development: "Development",
    form_many_participant_session_to_one_product: "Product",
    form_low: "Middle manual vocational program",
    form_high: "Master's degree",
    form_middle: "Bachelor's degree",
    form_male: "Male",
    form_other: "Other",
    form_female: "Female",
    form_one_participant_session_to_many_active_competency: "Select competencies",
    "form_nl-_n_l": "Dutch",
    "form_en-_g_b": "English",
    form_product_building_docks: "Building Docks",
    form_product_talent_fit: "Talent Fit",
    form_product: "Product",
    form_error_not_email: "The email address is invalid",
    form_product_wpq: "WPQ",
    form_product_personafit2: "Persona.fit 2",
    form_product_wpq_description: "...",
    form_product_persona_fit2_description: "...",
    form_product_building_docks_description: "Provides insight into how a participant deals with moral dilemmas.",
    form_product_talent_fit_description: "Quickly and objectively determine the match between talent and work environment (Bachelor / Master positions). With development tips for the participant and interview questions for the interviewer.",
    form_product_selection_description: "Provides insight into the match between a participant's profile and a specific position.",
    form_product_selection_development_description: "Provides insight into the match between a participant's profile and a specific position. Plus development tips.",
    form_product_development_description: "Provides insight into the qualities, development points of a participant and the degree of the ability to develop",
    form_error_selected_product_is_invalid_for_parent_organisation: "The selected product is invalid for this organisation",
    form_input_value_too_short: "The provided value needs to be between 2 and 255 characters in length.",
    form_input_value_too_long: "The provided value needs to be between 2 and 255 characters in length.",
    form_input_value_required: "This value is required.",
    form_choose_product_title: "Product",
    form_choose_completed_start_title: "Start date",
    form_choose_completed_end_title: "End date",
    form_product_persona_fit_2: "Persona.fit",
    form_option_role_finance: "Finance admin",
    form_enable_ability_tests: "Enable ability test(s)",
    form_ps_report_receivers: "Report receivers",
    form_product_talent_navigator_description: "Fast and objective development report with insight into qualities and points of attention. A good start to look at the development of an employee.",
    form_product_talent_navigator: "Talent Navigator",
    form_product_add_on_integrity: "Integrity",
    form_product_add_on_integrity_description: "This focus provides insight into the extent to which the participant acts with integrity. The report shows whether the participant acts more based on the individual or collective interest, given the profile and attitude of the participant.",
    form_is_demo_participant: "Is this a demo participant?",
    form_product_add_on: "Focus (optional)",
    form_option_role_client_admin: "Client Admin",
    form_product_pre_fit_description: "Fast identification of participants for the next step in the selection process.",
    form_product_pre_fit: "Pre Fit",
    form_cost_heading: "Cost heading (optional)",
    form_choose_cap_test_domain: "The ability test(s) shown below are included in the program.",
    form_choose_cap_test_domain_helper_text: "Choose at least two optional domains to increase the reliability. If you do not choose an optional domain, the general g-test will be used and you will see the score on general intellectual ability in the report. Note: this choice affects the test time.",
    "form_de-_d_e": "German",
    "form_fr-_f_r": "French",
    form_product_talent_scan_description: "An online selection tool that helps select the most talented employees for middle vocational functions.",
    form_product_talent_scan: "Talent Scan",
    form_product_add_on_work_safely: "Work safely",
    form_product_add_on_dealing_with_resistance: "Dealing with resistance",
    form_product_add_on_derailment: "Dealing with pressure",
    form_password_show: "Show",
    form_password_hide: "Hide",
    form_saved_changes: "Changes are saved",
    form_unsaved_changes: "Changes are unsaved",
    form_save_button: "Save",
    form_product_multi_phase: "2-Phase Talent Fit",
    form_product_multi_phase_description: "A two-phased online selection tool that helps select the best participants from a large pool of applicants.",
    form_choose_roles_subtitle: "Below you will find the different roles within Neon. Choose one or more roles.",
    form_choose_roles_title: "Which role(s) do you want to add?",
    form_choose_reports_title: "Which reports can the user see?",
    form_choose_reports_subtitle: "Choose one of the options below.",
    form_option_role_office_manager_no_report: "Coordinator",
    form_choose_organisations_subtitle: "Choose the organization that the user has access to.",
    form_choose_organisations_title_descriptive: "Which organization do you want to add the user to?",
    form_choose_organisations_placeholder: "Choose organisation",
    form_option_role_report_receiver: "Report receiver",
    form_all_reports_title: "All reports",
    form_all_reports_description: "With this role the user can see the reports of all participants of this organization.",
    form_no_reports_title: "No reports",
    form_no_reports_description: "The user can add participants but will not see any reports.",
    form_amend_roles_title: "Role(s)",
    form_product_add_on_critical_thinking: "Critical thinking",
    form_product_add_on_critical_thinking_description: "This add-on provides insight into the extent to which the participant is able to separate fact from assumptions and subsequently draw the correct conclusions.",
    form_product_add_on_derailment_description: "This add-on provides insight into which toxic behaviour can emerge in the employee under pressure.",
    form_product_add_on_work_safely_description: "This add-on provides the insight in the factors that influence the risk-taking in the field of working safely.",
    form_product_add_on_dealing_with_resistance_description: "The way in which the employee deals with resistance determines work performance. This add-on provides insight into the risks.",
    form_product_add_on_no_extra_time: "No extra time",
    form_product_add_on_integrity_extra_time: "±45 minutes",
    form_product_add_on_critical_thinking_extra_time: "±30 minutes",
    form_product_team_and_organisation: "Team & Organisation",
    form_product_team_and_organisation_description: "This product fosters transparent communication and provides intuitive collaboration tools, enabling teams and organizations to better understand each other's perspectives and foster cohesion.",
    form_product_add_on_dilemma_test: "Dilemma test",
    form_product_add_on_dilemma_test_description: "An ethical dilemma test evaluates the decision-making process in complex situations to assess ethical reasoning. It tests the ability to analyze scenarios and make informed judgments based on moral principles.",
    form_product_add_on_dilemma_test_extra_time: "±30 minutes",
    form_download: "Download",
    form_assessment_form_description: "Choose between an online scan or a complete assessment with a psychologist",
    form_assessment_form_title: "Design your assessment",
    form_assessment_form_with_interpretation_title: "Live assessment",
    form_assessment_form_without_interpretation_title: "Online assessment",
    form_assessment_form_with_interpretation_description: "This option is chosen when you want to add the interpretation by an LTP psychologist additionally. This makes decision-making even easier",
    form_assessment_form_without_interpretation_description: "The standard is an automated report after completion of the questionnaires. There is no interpretation from an LTP psychologist.",
    form_assessment_form_without_interpretation_time_indication: "No extra time",
    form_assessment_form_with_interpretation_time_indication: "+ 3 - 8 hours on LTP location",
    form_points_of_attention: "Use the next field to add details to plan the assessment:\n<ul>\n<li>Do we need a context analysis? If so who is the contact person and what is the best way to reach out to them. Please provide full contact details.\n</li><li>\nThe same question but for reviewing the outcome of the assessment.\n</li><li>\nAny other points of attention.\n</li>\n</ul>",
    form_points_of_attention_placeholder: "Please add additional information needed to plan the assessment",
    form_project_prompt_name_placeholder: "Add the job title as used in AI prompts here",
    form_project_prompt_description_placeholder: "Add information about this job function that will be used in AI prompts",
    form_assessment_interpretation_title: "Interpretation",
    form_assessment_interpretation_description: "By selecting this is option, you can add interpretation by a psychologist to your online assessment.",
    form_assessment_interpretation_enabled: "Enabled",
    form_assessment_interpretation_disabled: "Disabled",
    form_product_test_ned: "TestNed Scan",
    form_product_test_ned_description: "Online scan as a starting point for an employment assessment",
    form_product_test_ned_periodic: "TestNed Scan Periodic",
    form_product_test_ned_periodic_description: "Periodic assessments for TestNed",
    form_interpretation_basic: "Interpretation Silver",
    form_interpretation_compact: "Interpretation Compact",
    form_interpretation_regular: "Interpretation Gold",
    form_interpretation_premium: "Interpretation Premium",
    form_file_uploader_button: "Browse",
    form_profile_files_title: "2. Files attached to the profile",
    form_error_password_not_valid: "The password should be a minimum of 12 characters, contain an upper and lowercase character, a special character and a digit",
    form_assessment_goal_description: "Choose from mapping development potential, a selection issue or a combination of both.",
    form_assessment_goal_title: "Choose your goal",
    form_assessment_form_development_description: "Gain insight in the ability to develop",
    form_assessment_form_selection_development_description: "Identify the best fitting candidates for a role and consider their potential for growth",
    form_assessment_form_selection_description: "Identify the best fitting candidates for a role",
    form_assessment_form_development_title: "Development",
    form_assessment_form_selection_development_title: "Selection Development",
    form_assessment_form_selection_title: "Selection",
    form_unspecified: "I prefer not to say that",
    form_option_unspecified: "I prefer not to say that",
    form_raf_product_selection: "Extensive selection assessment",
    form_raf_product_selection_development: "Extensive selection-development assessment",
    form_raf_product_development: "Extensive development assessment",
    form_interpretation_periodicAssessmentTestNed: "TestNed Scan Periodic",
    form_language: "Preferred language",
    form_profile_cv_title: "1. Add function profile here, the participant will be asked to upload their CV",
    form_plan_in_neon_toggle_label: "Plan the appointment in NEON",
    form_participant_files_title: "3. Add participant-related files",
    form_product_no_online_scan: "Without online scan",
    form_product_no_online_scan_description: "Only available for participants who have already done a separate online scan with a complete report.",
    form_file_item_upload_fail: "Error during upload",
    form_file_item_upload_success: "Upload complete",
    form_project_files_uploader_drag_and_drop: "Drag & Drop project files",
    form_files_uploader_remove_file_modal_description: "You are about to delete a file. This means the file can no longer be viewed when writing a report. Are you sure you want to delete the file?",
    form_files_uploader_remove_file_modal_delete_button: "Delete",
    form_files_uploader_remove_file_modal_title: "Delete file",
    form_files_uploader_error_upload: "Could not upload the file",
    form_files_uploader_error_delete: "Could not delete the file",
    form_files_uploader_error_open: "Could not open the file",
    form_is_pre_assessment_call_necessary: "Is a pre-assessment call with the manager necessary?",
    form_manager_name_placeholder: "Enter manager's full name",
    form_manager_phone_placeholder: "Enter manager's phone number",
    form_manager_name_label: "Manager name",
    form_manager_phone_label: "Manager phone number",
    form_report_receivers_add: "Add new receiver",
    form_report_receivers_empty_state_header: "No report receivers selected",
    form_report_receivers_empty_state_paragraph_1: "Do you want to share the report with another user?",
    form_report_receivers_empty_state_paragraph_2: "Search the user and select them or add a new user with the \"Add new receiver\" button",
    form_update_button_label: "Update",
    form_report_receivers_remove_tooltip: "Remove",
    form_cv_uploader_drag_and_drop: "Drag & Drop CV file",
    form_file_uploader_paragraph: "or, click to browse",
    form_file_uploaded_success: "The file uploaded successfully",
    form_education_level_description: "The requested level is needed to give you the right assessment for your question. In addition, it is also used for the capacity tests if these are included in the program.",
    form_education_level_title: "What is the required level for this profile?",
    form_education_level_low_description: "This profile is an \"executive\" profile in which the participant primarily works in execution.",
    form_education_level_middle_description: "This profile is a \"professional\" profile in which the participant focuses not only on execution but also on policy.",
    form_education_level_high_description: "This profile is a \"professional or executive\" profile in which the participant has a policy focus or is suited for higher executive positions.",
    form_education_level_high_title: "Master's degree",
    form_education_level_middle_title: "Higher vocational program",
    form_education_level_low_title: "Middle manual vocational program",
    form_product_executive_scan: "Executive Scan",
    form_product_executive_scan_description: "A scan for executive positions aimed at measuring leadership qualities, strategic insight, and personal effectiveness, with critical reasoning as a standard component of the program.",
    form_error_email_contains_space: "Email address cannot contain space",
    form_interpretation_executive: "Compact Executive Assessment",
    form_interpretation_cLevel: "Executive Assessment",
    form_internal_participant_toggle_checked: "Yes, the report is only available for the report receiver(s) of this participant",
    form_internal_participant_toggle_unchecked: "No, the report is available for colleagues and report receiver(s)",
    form_pre_assessment_call_toggle_unchecked: "No, the call is not necessary",
    form_points_of_attention_short: "Points of attention",
    form_participant_phone_label: "Participant's phone number",
    form_participant_employee_number: "Participant's employee number",
    form_invited_email_address: "Invited e-mail address",
    form_registered_email_address: "Registered e-mail address",
    form_warning_email_addresses_different: "The invited and registered e-mail addresses are not the same",
    form_files_uploader_error_file_size: "Files larger than 5 MB cannot be uploaded",
    form_career_position_starter_title: "Starter",
    form_career_position_professional_title: "Professional",
    form_career_position_manager_title: "Manager",
    form_career_position_executive_title: "Executive",
    form_option_role_team_manager: "Team manager",
    form_option_role_team_admin: "Team admin"
};
